import store from "../store";
import axios from "../axios";
//
const getDashi = async () => {
  axios.get("/crm/dashi").then(res => {
    console.log(res);
  });
};

//加载数据
const loadSxyc = async () => {
  let prms = store.getters.sxQry;
  let path = prms.sxi && prms.sex && prms.sxy ? '/suan/sxyc/read' : '/suan/sxyc'
  store.commit('setIsLoad', true)
  return axios
    .get(path, { params: prms })
    .then(res => {
      store.commit("setBase", res.data)
      store.commit('setIsLoad', false)
    })
    .catch(err => {
      console.log(err);
    });
};

export default {
  getDashi,
  loadSxyc
};
